var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"empty-img",style:({ width: _vm._Size + 'px' }),attrs:{"src":require("../../assets/images/empty.png"),"alt":""}}),_vm._v(" "),(_vm._Title)?_c('p',[_vm._v(_vm._s(_vm._Title))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac59168","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/empty/Main.vue
// module id = null
// module chunks = 